import { Component, Injector, ViewChild } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import AppComponentBase from '@shared/common/app-component-base';
import UtilsModule from '@shared/utils/utils.module';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'app-footer-settings-menu',
    templateUrl: './footer-settings-menu.component.html',
    styleUrls: ['./footer-settings-menu.component.less'],
    standalone: true,
    imports: [
        OverlayPanelModule,
        TooltipModule,
        UtilsModule,
    ],
})
class FooterSettingsMenuComponent extends AppComponentBase {
    @ViewChild('menuPanel') menuPanel: OverlayPanel;

    constructor(injector: Injector) {
        super(injector);
    }

    toggle(event: Event): void {
        this.menuPanel.toggle(event);
    }

    clearCache(): void {
        this.menuPanel.hide();
        localStorage.removeItem(AppConsts.CacheStorageKey);
        this.notify.success(this.l('ClearCachedDataSuccess'));
        window.location.reload();
    }

    // Reusable confirm wrapper for future destructive menu actions.
    protected confirmAndRun(messageKey: string, titleKey: string, action: () => void): void {
        this.message.confirm(this.l(messageKey), this.l(titleKey), (isConfirmed) => {
            if (isConfirmed) {
                action();
            }
        });
    }
}

export default FooterSettingsMenuComponent;
